import { styled, Typography } from '@mui/material';

export const DpHelpCenterTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
	<Typography
		component="h2"
		sx={{
			fontSize: { xs: 'var(--font-size-lg)', md: 'var(--font-size-xl)' },
			fontWeight: 800,
			textTransform: 'uppercase',
			mb: { xs: 'var(--spacing-1)', sm: 'var(--spacing-2)' },
		}}
	>
		{children}
	</Typography>
);

export const DpHelpCenterSubtitle: React.FC<React.PropsWithChildren> = ({ children }) => (
	<Typography
		sx={{
			fontSize: 'var(--font-size-body)',
			mb: 'var(--spacing-5)',
		}}
	>
		{children}
	</Typography>
);

export const DpHelpCenterUl = styled('ul')<{
	yspace?: boolean;
	topspace?: boolean;
}>(({ yspace = false, topspace = false }) => ({
	margin: 0,
	marginTop: topspace ? '1rem' : yspace ? '1rem' : 0,
	marginBottom: yspace ? '1rem' : 0,
}));

export const DpHelpCenterOl = styled('ol')<{
	yspace?: boolean;
	topspace?: boolean;
}>(({ yspace = false, topspace = false }) => ({
	margin: 0,
	marginTop: topspace ? '1rem' : yspace ? '1rem' : 0,
	marginBottom: yspace ? '1rem' : 0,
}));

export const DpHelpCenterLi = styled('li')(() => ({
	fontSize: 'var(--font-size-body)',
}));

export const DpHelpCenterP = styled('p')(() => ({
	fontSize: 'var(--font-size-body)',
	margin: 0,
}));
